const colors = {
  BRAND_GREEN:      '#417505',
  ORANGE_HIGHLIGHT: '#F6A623',
  ORANGE_ALT:       '#f19500',
  GRAY_LIGHT:       '#A8A8A8',
  GRAY_LIGHTER:     '#D8D8D8',
  GRAY_ULTRA_LIGHT: '#E5E5E5',
  GRAY_MEGA_LIGHT:  '#f4f4f4',
  GRAY_SEARCH_ICON: '#A3A3A3',
  GRAY_SEMI:        '#9B9B9B',
  GRAY_SEMI_DARK:   '#828282',
  GRAY_DARK:        '#4A4A4A',
  TRANSPARENT:      'transparent',
  WHITE:            '#fff',
  BLOCKED:          '#c9c9c9',
  BASIC_RED:        '#ED5564',
  FIELD_ERROR:      '#ed5564',
  BORDER_COLOR:     '#CED5D8',
  TEXT_COLOR:       '#6F6F6F',
  GPG_BLUE:         '#265b9d',
  BRAND_BLUE:       '#07B3B2',
}
//#[0-9a-f]{3,6}
export default colors;



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/colors.js